import styled, { css } from 'styled-components/macro'
import { ColorsMap, device } from '../../../utils/Theme'
import {} from './Registration'

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const StyledForm = styled.form`
  margin: 0 auto;
  width: 85%;
  @media (max-width: ${device.mobile}) {
    width: 70%;
  }
  @media (max-width: ${device.mobileS}) {
    width: 85%;
  }
`

export const StyledRegistration = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 900px;
`

export const InputWrapper = styled.div`
  * {
    margin: 0.25rem auto;
  }
  @media (min-width: ${device.mobile}) {
    display: flex;
    * {
      margin: 0.25rem 1rem;
    }
  }
`

export const UploadTextPosition = styled.div`
  position: absolute;
  bottom: 1rem;
`
export const Flex = styled.div`
  display: flex;
  * {
    margin: 0;
    &:nth-child(2) {
      margin-left: 0.25rem;
    }
  }
`
